import { Validateable } from "@models/interfaces";

export class SecurityTokenToggleSlider extends Validateable {
	public securityTerms: boolean = false;

	public getAllEnabled(): boolean {
		return this.securityTerms;
	}

	public wiggleAll(): void {
		this.wiggle("securityTerms");
	}

	public disableSliders(): void {
		this.securityTerms = false;
	}
}
